export default __webpack_public_path__ + "static/AICPA-e6532e7365b4d97af23b856e57877688.png";